module.exports = __webpack_public_path__ + "img/disable-diagnostic.ce09ac1e.svg";